<style>
html { overflow-x: hidden; overflow-y: hidden; }
	.bg2233 {
		background-color: #f3f7f8;width:100%;height:100vh;
		background-image: linear-gradient(to bottom right, #c1e5fc, #fefefe);
		margin: 0 auto;padding: 0;overflow: hidden;
	}
 
.home_left{width:35vw;height:42vw;background-color:#fff;border-radius:.5vw;
 float:left;margin-top:5vw;margin-left:14vw;cursor:pointer;font-family:"PingFang"}
.home_left img{display:block;width:8vw;margin-top:15vw;}
.home_left button{display:block;margin:0 auto;border:0;background:#3465ff;
        outline:none;color:#fff;height:4vw;line-height:4vw;font-size:1.4vw;font-family:"PingFang";
		padding:0 3vw;border-radius:.2vw;margin-top:2vw;}
.home_right{width:35vw;float:right;height:42vw;margin-top:5vw;
           margin-right:14vw;cursor:pointer;}
.right_top{margin:0;padding:0;overflow:hidden;width:100%;height:20vw;background:#fff;border-radius:.5vw;}
.right_top img{display:block;width:8vw;margin-top:3vw;}
.right_top button{display:block;margin:0 auto;border:0;background:none;
        outline:none;color:#000;height:4vw;line-height:4vw;font-size:1.6vw;
		padding:0 3vw;border-radius:.2vw;margin-top:0;}
.right_bottom{width:100%;height:21.2vw;margin-top:.8vw;}
.bottom_left{background:#fff;border-radius:.5vw;width:17vw;height:100%;float:left;}
.bottom_right{float:right;}
.right_bottom img{display:block;width:8vw;margin-top:3vw;}
.right_bottom button{display:block;margin:0 auto;border:0;background:none;
        outline:none;color:#000;height:4vw;line-height:4vw;font-size:1.6vw;
		padding:0 3vw;border-radius:.2vw;margin-top:0;}
.copyright{width:95vw;margin:0 auto;height:10vw; padding:0;overflow:hidden;}
.copyright span{display:block;width:30vw;line-height:10vw;font-size:1.2vw;
  }
.copyright span.cp1{float:left;text-align:left;}
.copyright span.cp2{float:right;text-align:right;}

.index_bg_box{width: 78vw;margin: 0 auto;padding: 0;overflow: hidden;height: 30vh;margin-top:25vh;}
.index_box1{width: 13vw;height: 100%;background-color: #fff;float: left;border-radius:1vw;background-color:#fff;cursor: pointer;
background-size: 80%;background-repeat: no-repeat;background-position: center top;position: relative;margin-left: 1vw;}
.bg1{width: 100%;height: 100%;background-image: linear-gradient(to bottom, #67ffcf, #00c0fa);display: none;}
.index_box1 img{position: absolute;top: 5vh;width: 50%;}
.index_box1 img.img1{left: 25%;display: block;}
.index_box1 img.img2{left: 25%;display: none;}
.index_box1 img.tag{width: 3.5vw;right: 0;top: 0;height: auto;display: block;}
.index_box1 span{position: absolute;left: 0;top: 20vh;width: 100%;display: block;text-align: center;font-size: 1.4vw;}
.index_box1 span.w1{display: block;}
.index_box1 span.w2{display: none;}
.index_box1:hover .bg1{display: block;border-radius:1vw;}
.index_box1:hover img.img1{left: 25%;display: none;}
.index_box1:hover img.img2{left: 25%;display: block;}
.index_box1:hover span.w1{display: none;}
.index_box1:hover span.w2{display: block;color: #fff;}
.index_box1:hover img.tag{display: block;}

.index_box2{width: 22vw;height: 100%;background-color: #fff;float: left;border-radius:1vw;background-color:#fff;cursor: pointer;
background-size: 80%;background-repeat: no-repeat;background-position: center top;position: relative;margin-left: 1vw;}
.bg2{width: 100%;height: 100%;background-image: linear-gradient(to bottom, #67ffcf, #00c0fa);display: none;}
.index_box2 img{position: absolute;left: 0;top: 2.5vh;width: 40%;left: 30%;}
.index_box2 img.img11{display: block;}
.index_box2 img.img22{display: none;}
.index_box2 button{position: absolute;left: 30%;top: 20vh;width: 40%;display: block;text-align: center;font-size: 1.4vw;
color:#fff;font-size: 1.4vw;outline: none;height:3vw;line-height: 3vw;border-radius: .5vw; }
.index_box2 button.b1{display: block;background-color: #3e75f6;border:#3e75f6 solid 1px;}
.index_box2 button.b2{display: none;}
.index_box2:hover .bg2{display: block;border-radius:1vw;}
.index_box2:hover img.img11{display: none;}
.index_box2:hover img.img22{display: block;}
.index_box2:hover button.b1{display: none;}
.index_box2:hover button.b2{display: block;background: none;border:#fff solid 1px;}

.index_bottom2{width: 100%;height: 5vw;position: fixed;bottom: 6vw;}
.index_bottom2 img{width: 100%;height: auto;}
.copyrights{width: 100%;height: 5vw;position: fixed;bottom: 2vw;}
.copyrights span{display: block;width: 100%;text-align: center;font-size: 1.1vw;line-height: 1.6vw;color: #69c;font-weight: normal;}


.index_box3{width: 13vw;height: 100%;background-color: #fff;float: left;border-radius:1vw;background-color:#fff;cursor: pointer;
background-size: 80%;background-repeat: no-repeat;background-position: center top;position: relative;margin-left: 1vw;}
.bg3{width: 100%;height: 100%;background-image: linear-gradient(to bottom, #67ffcf, #00c0fa);display: none;}
.index_box3 img{position: absolute;top: 2vh;width: 80%;}
.index_box3 img.img1{left: 10%;display: block;}
.index_box3 img.img2{left: 10%;display: none;}
.index_box3 img.tag{width: 3.5vw;right: 0;top: 0;height: auto;}
.index_box3 span{position: absolute;left: 0;top: 20vh;width: 100%;display: block;text-align: center;font-size: 1.4vw;}
.index_box3span.w1{display: block;}
.index_box3 span.w2{display: none;}
.index_box3:hover .bg3{display: block;border-radius:1vw;background-image: linear-gradient(to bottom, #fff, #fff);}
 
</style>
<template>
	<div class="bg2233">
	 
		  <u_center  :logins="login" @logins="logins"></u_center>
		  <div class="index_bg_box">
		  	<div class="index_box1" style="margin-left:0" @click="template()">
		  		<div class="bg1"></div>
		  		<img class="img1" src="../../assets/images/icon1.svg">
		  		<img class="img2" src="../../assets/images/icon11.svg">
		  		<span class="w1">短信模板</span>
                                <span class="w2">短信模板</span>
		  	</div>
		  	<div class="index_box1" @click="store()">
		  		<div class="bg1"></div>
		  		<img class="img1" src="../../assets/images/icon2.svg">
		  		<img class="img2" src="../../assets/images/icon22.svg">
		  		<span class="w1">数据仓库</span>
                                <span class="w2">数据仓库</span>
		  	</div>
		  	<div class="index_box2" @click="send()">
		  		<div class="bg2"></div>
		  		<img class="img11" src="../../assets/images/icon3.png">
		  		<img class="img22" src="../../assets/images/icon33.png">
		  		<button class="b1">发送短信</button>
                                <button class="b2">发送短信</button>
		  	</div>
		  	<div class="index_box1" @click="hudong()">
		  		<div class="bg1"></div>
		  		<img class="img1" src="../../assets/images/icon3.svg">
		  		<img class="img2" src="../../assets/images/icon33.svg">
		  		<img class="tag" src="../../assets/images/tag.png">
		  		<span class="w1">互动内容</span>
                                <span class="w2">互动内容</span>
		  	</div>
                        <div class="index_box1" @click="send_history()">
		  		<div class="bg1"></div>
		  		<img class="img1" src="../../assets/images/icon4.svg">
		  		<img class="img2" src="../../assets/images/icon44.svg">
		  		<span class="w1">发送记录</span>
                                <span class="w2">发送记录</span>
		  	</div>
		  </div>
		  <div class="index_bottom2">
		  	<img src="../../assets/images/index_bottom2.png">
		  </div>
		  <div class="copyrights">
		  	<span class="c1">MDK×EDU ©2015-2023</span>
		  	<span class="c2">客服：028-85071717  /  180-8080-2211</span>
		  	<!-- <span class="c3">www.scedu.tech</span> -->
		  </div>
		 <!-- <div class="home_left" @click="send()" @mouseover="mouseOver(1)"  @mouseleave="mouseLeave(1)" :style="style1">
		   <img src="../../assets/images/sms_icon.png">
		   <button >发送短信通知</button>
		 </div>
		 <div class="home_right">
		    <div class="right_top" @click="template()" @mouseover="mouseOver(2)"  @mouseleave="mouseLeave(2)" :style="style2">
			    <img src="../../assets/images/temp_icon.png">
		        <button >管理短信模板</button>
			</div>
			<div class="right_bottom" >
			   <div class="bottom_left" @click="send_history()"  @mouseover="mouseOver(3)"  @mouseleave="mouseLeave(3)"  :style="style3">
			      <img src="../../assets/images/record_icon.png">
		          <button>发送记录</button>
			   </div>
			   <div class="bottom_left bottom_right" @click="store()" @mouseover="mouseOver(4)"  @mouseleave="mouseLeave(4)"   :style="style4">
			      <img src="../../assets/images/store_icon.png">
		        <button>数据仓库</button>
			   </div>
			</div>
		 </div>
		 <div class="copyright">
		    <span class="cp1" >技术支持：www.scedu.tech</span>
			<span class="cp2">当前版本：5.1.0</span>
		 </div> -->
		
	</div>
</template>
<script>
	import u_center from '@/components/u_center.vue';  
	export default {
	     components: {
		  u_center,
	    },
		data() {
			return {
				active:"height:10vw;" ,
				u_menu:false,
		                style1:"background-color:#fff;",
				style2:"background-color:#fff;",
				style3:"background-color:#fff;",
				style4:"background-color:#fff;",
				shenggyu:false,
	                        token:"",
				login:false,
				type:""
			}
		},
		mounted() {
		    let self=this;
		    var token= localStorage.getItem("token");
			 if(token){
			     this.token=token;
			     this.get_sms_type();
			 }	
		},
		methods: {
		        get_sms_type(){	        
			      let self=this;
			      axios.post(this.$api+'/message/get_sms_type', {
						   token:self.token
			      }).then(function (response) {  
				      let data=response.data;
					  if(data.state==1){ 
					         var step=  data.data;             
						 if(step[0]){
							 
							self.type=step[0].id;
						 }
						 				 
					  } 
			      }).catch(function (error) {
				         
			      });
		        }, 
		        store(){
				 var token= localStorage.getItem("token");
				 if(token){
					  this.$router.push("/sms_list"); 
				 }else{
				     this.login=true;
				     return;
				 }		   
			},logins(val){
			   this.login=val;
			   this.get_sms_type();
			},
			template(){
			     var token= localStorage.getItem("token");
				 if(token){
			             this.$router.push("/select_add?type="+this.type);
				 }else{
				     this.login=true;
				     return;
				 }	
			}, send(){
			     var token= localStorage.getItem("token");
				 if(token){
			               this.$router.push("/select_template"); 
				 }else{
				     this.login=true;
				     return;
				 }	
			}, send_history(){

                                  var token= localStorage.getItem("token");
				 if(token){
					  this.$router.push("/send_history"); 
				 }else{
				     this.login=true;
				     return;
				 }
			},hudong(){
				 this.$toast.center('即将上线');
     //                             var token= localStorage.getItem("token");
				 // if(token){
					//   this.$router.push("/interact"); 
				 // }else{
				 //     this.login=true;
				 //     return;
				 // }
			},
		    mouseOver(val) {
			   if(val==1){
			     this.style1='background-color:#f1f1f1';
			   }else if(val==2){
			     this.style2='background-color:#f1f1f1';
			   }else if(val==3){
			     this.style3='background-color:#f1f1f1';
			   }else if(val==4){
			     this.style4='background-color:#f1f1f1';
			   }
		   },mouseLeave(val) {
               if(val==1){
			     this.style1='background-color:#fff';
			   }else if(val==2){
			     this.style2='background-color:#fff';
			   }else if(val==3){
			     this.style3='background-color:#fff';
			   }else if(val==4){
			     this.style4='background-color:#fff';
			   }
           } 
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/home/index.vue